import { Controller } from '@hotwired/stimulus'
import escapeHtml from '../../utils/sanitize'
import fetchWithHandlingLoginRedirect from '../../modules/utils/fetchWithHandlingLoginRedirect'
import {
  trans,
  ERROR_UNKNOWN,
  ERROR_PERMISSION_DENIED
} from '../../translator'

export default class extends Controller {
  static values = {
    threatCategoryId: String,
    threatCategoryChildren: Array
  }

  static targets = [
    'addKeyword', 'addKeywordCancel', 'addKeywordConfirm', 'addKeywordText', 'addKeywordDiv', 'keywordText', 'keywordTemplate'
  ]

  addKeyword () {
    this.addKeywordTarget.classList.add('d-none')
    this.addKeywordConfirmTarget.classList.remove('d-none')
    this.addKeywordCancelTarget.classList.remove('d-none')
    this.addKeywordTextTarget.classList.remove('d-none')
    this.addKeywordTextTarget.focus()
  }

  cancelAddKeyword () {
    this.addKeywordConfirmTarget.classList.add('d-none')
    this.addKeywordCancelTarget.classList.add('d-none')
    this.addKeywordTarget.classList.remove('d-none')
    this.addKeywordTextTarget.textContent = ''
    this.addKeywordTextTarget.classList.add('d-none')
  }

  confirmAddKeyword () {
    fetchWithHandlingLoginRedirect(
      `/internal/api/threat-categories/${this.threatCategoryIdValue}/keywords`,
      {
        method: 'POST',
        body: JSON.stringify({
          keyword: escapeHtml(this.addKeywordTextTarget.textContent)
        })
      })
      .then(response => {
        if (!response.ok) {
          return response
        }

        const newKeyword = this.keywordTemplateTarget.cloneNode(true)
        newKeyword.innerHTML = this.addKeywordTextTarget.textContent + newKeyword.innerHTML
        newKeyword.classList.remove('d-none')
        newKeyword.removeAttribute('data-threat-category-target')

        this.addKeywordDivTarget.parentNode.insertBefore(newKeyword, this.addKeywordDivTarget)

        this.addKeywordTextTarget.textContent = ''
        this.addKeywordTextTarget.classList.add('d-none')

        this.addKeywordConfirmTarget.classList.add('d-none')
        this.addKeywordCancelTarget.classList.add('d-none')
        this.addKeywordTarget.classList.remove('d-none')
      })
      .catch(async error => {
        let errorMessage = trans(ERROR_UNKNOWN, {}, 'threat-categories')
        switch (error.status) {
          case 400:
            errorMessage = (await error.json())[0]
            break
          case 403:
            errorMessage = trans(ERROR_PERMISSION_DENIED, {}, 'threat-categories')
            break
        }

        const originalText = this.addKeywordTextTarget.textContent
        this.addKeywordTextTarget.textContent = this.addKeywordTextTarget.textContent + ' (' + errorMessage + ')'
        this.addKeywordDivTarget.classList.add('red')
        this.addKeywordTextTarget.classList.add('red')
        setTimeout(() => {
          this.addKeywordTextTarget.textContent = originalText
          this.addKeywordDivTarget.classList.remove('red')
          this.addKeywordTextTarget.classList.remove('red')
        }, 1000)
      })
  }

  removeKeyword (event) {
    const removeButton = event.currentTarget
    const keyword = event.currentTarget.parentNode
    fetchWithHandlingLoginRedirect(
      `/internal/api/threat-categories/${this.threatCategoryIdValue}/keywords`,
      {
        method: 'DELETE',
        body: JSON.stringify({
          keyword: escapeHtml(keyword.textContent)
        })
      })
      .then(response => {
        if (!response.ok) {
          return Promise.reject(response)
        }

        keyword.classList.add('disabled')
        removeButton.classList.add('d-none')
        removeButton.nextSibling.classList.remove('d-none')
      })
      .catch(() => {
        keyword.classList.add('red')
        setTimeout(() => {
          keyword.classList.remove('red')
        }, 1000)
      })
  }

  reAddKeyword (event) {
    const reAddButton = event.currentTarget
    const keyword = event.currentTarget.parentNode
    fetchWithHandlingLoginRedirect(
      `/internal/api/threat-categories/${this.threatCategoryIdValue}/keywords`,
      {
        method: 'POST',
        body: JSON.stringify({
          keyword: escapeHtml(keyword.textContent)
        })
      })
      .then(response => {
        if (!response.ok) {
          return Promise.reject(response)
        }

        keyword.classList.remove('disabled')
        reAddButton.classList.add('d-none')
        reAddButton.previousSibling.classList.remove('d-none')
      })
      .catch(() => {
        keyword.classList.add('red')
        setTimeout(() => {
          keyword.classList.remove('red')
        }, 1000)
      })
  }
}
